import Select, { GroupBase, OptionsOrGroups, SingleValue } from "react-select";

interface IProps<T> {
  options: OptionsOrGroups<T, GroupBase<T>>;
  onChange: (newValue: SingleValue<T>) => void;
  value: SingleValue<T>;
  placeholder: string;
  inputId: string;
  instanceId: string;
  id: string;
  isSearchable: boolean;
  isClearable?: boolean;
}

const CustomSelect = <T extends object>(selectProps: IProps<T>) => {
  return (
    <Select
      {...selectProps}
      // components={{
      //   DropdownIndicator: CaretDown,
      // }}
      styles={{
        container: (provided) => ({
          ...provided,
          width: "100%",
          fontFamily: "RiposteRegular",

          "&:focus-visible": {
            outline: "none",
          },
        }),

        control: (provided) => ({
          ...provided,

          border: "1px solid rgba(0, 0, 0, 0.3)",
          borderRadius: "5px",
          boxShadow: "none",
          height: "50px",
          textAlign: "left",
          "&:hover": {
            cursor: "pointer",
          },
        }),

        menu: (provided) => ({
          ...provided,
          width: "100%",
        }),

        input: (provided) => ({
          ...provided,

          color: "#000",
        }),

        placeholder: (provided) => ({
          ...provided,
        }),

        indicatorSeparator: (provided) => ({
          ...provided,
          display: "none",
        }),

        indicatorsContainer: (provided, state) => ({
          ...provided,
          // padding: "0 18px",
        }),

        dropdownIndicator: (provided, state) => ({
          ...provided,
          transition: "all .2s ease",
          transform: state.isFocused ? "rotate(180deg)" : "rotate(0)",
        }),

        option: (provided, state) => ({
          ...provided,

          color: state.isSelected ? "#fff" : "#000",
          background: state.isSelected ? "#c4c4c4" : "#fff",
          padding: 10,
          textAlign: "left",

          "&:hover": {
            background: "#c4c4c4",
            color: "#fff",
            cursor: "pointer",
          },
        }),
      }}
    />
  );
};

export default CustomSelect;
